import { createSlice } from "@reduxjs/toolkit";

const globalSlice = createSlice({
  name: "global",
  initialState: {
    updateProfile: false,
    changePasswordModal: false,
    addModal: false,
    updateModal: false,
    updateId: null,
    bool: false,
    filter: false,
  },
  reducers: {
    toggleUpdateProfileModal: (state) => {
      state.updateProfile = !state.updateProfile;
    },
    toggleChangePasswordModal: (state) => {
      state.changePasswordModal = !state.changePasswordModal;
    },
    toggleAddModal: (state) => {
      state.addModal = !state.addModal;
    },
    toggleUpdateModal: (state, action) => {
      state.updateId = action?.payload?.id
      state.updateModal = !state.updateModal;
    },
    toggleBool: (state) => {
      state.bool = !state.bool;
    },
    toggleFilter: (state) => {
      state.filter = !state.filter;
    },
  },
});

// Export actions
export const { toggleUpdateProfileModal, toggleChangePasswordModal, toggleAddModal, toggleUpdateModal, toggleBool, toggleFilter } = globalSlice.actions;

// Export reducer
export default globalSlice.reducer;
